import $ from 'jquery';
import blockBody from '../lib/utils/blockBody';
import shouldManageBodyStyle from '../lib/utils/should-manage-body-style';

const toggleMobileMenu = () => {

    const $openBtn = $('.js-mobile-menu-opener');
    const $closeBtn = $('.js-mobile-menu-closer');
    const $mobileMenu = $('.js-mobile-menu');
    const $overlay = $('.js-mobile-menu-overlay');

    if (!$openBtn.length || !$closeBtn.length || !$mobileMenu.length || !$overlay.length) {
        return;
    }

    const activeClass = 'active';
    let shouldBodyBeControlled = true; // the variable will help to decide, whether we should delete the 'ov-hidden' class from body after closing the popup or not (if another popup is opened under it, we shouldn't do it)

    function openMenu() {
        $mobileMenu.addClass(activeClass);
        $overlay.addClass(activeClass);
        shouldBodyBeControlled = shouldManageBodyStyle();
        if (shouldBodyBeControlled) {
            blockBody().block();
        }
    }

    function closeMenu() {
        $mobileMenu.removeClass(activeClass);
        $overlay.removeClass(activeClass);
        if (shouldBodyBeControlled) {
            blockBody().unblock();
        }
    }

    $openBtn.on('click', () => {
        openMenu();
    });

    $closeBtn.on('click', () => {
        closeMenu();
    });

    $overlay.on('click', () => {
        closeMenu();
    });

};

export default toggleMobileMenu;
